import axiosInstance from '@/core/api'
import {
	UpdateAnnouncementRequest,
	UpdateAnnouncementResponse,
	CreateAnnouncementRequest,
	CreateAnnouncementResponse,
	GetAnnouncementRequest,
	GetAnnouncementResponse,
	GetAnnouncementByIdResponse,
} from '../../type'

export const getAnnouncement = async (request: GetAnnouncementRequest) => {
	const response = await axiosInstance.get<GetAnnouncementResponse>(
		'/admin/announcements/get-announcement',
		{
			params: request,
		},
	)
	return response.data
}

export const getAnnouncementById = async (id: string) => {
	const response = await axiosInstance.get<GetAnnouncementByIdResponse>(
		`/admin/announcements/get-announcement/${id}`,
	)
	return response.data
}

export const createAnnouncement = async (
	request: CreateAnnouncementRequest,
) => {
	const response = await axiosInstance.post<CreateAnnouncementResponse>(
		'/admin/announcements/create-announcement',
		request,
	)
	return response.data
}

export const deleteAnnouncement = async (id: string) => {
	const response = await axiosInstance.delete<void>(
		`/admin/announcements/delete-announcement/${id}`,
	)
	return response.data
}

export const updateAnnouncement = async (
	id: string,
	request: UpdateAnnouncementRequest,
) => {
	const response = await axiosInstance.patch<UpdateAnnouncementResponse>(
		`/admin/announcements/update-announcement/${id}`,
		request,
	)
	return response.data
}
